/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.security-manager.client.show').directive('gccsClientShowDetailsManagers', () =>
  ({
    restrict: 'A',
    controller: 'ClientShowDetailsManagersController',
    controllerAs: 'clientShowDetailsManagersCtrl',
    template: require('./template.pug'),
    scope: {
      clientId: '=',
      editable: '<'
    }
  })
);
